/** localStorage key for the auth JWT. Used by AuthContext and api/http. */
export const TOKEN_STORAGE_KEY = "token";
